import * as trace from 'owa-trace';
import {
    CONTACT,
    EXTERNAL_MAILBOX,
    IMPLICIT_CONTACT,
    INTERNAL_MAILBOX,
    LINKED_IN,
    MAILBOX,
    ONE_OFF,
    OTHER,
    PUBLIC_FOLDER,
    ROOM,
} from '../constants';
import { isDLOrGroup } from './isDLOrGroup';

export function isIndividualRecipient(mailboxType: string) {
    switch (mailboxType) {
        case INTERNAL_MAILBOX:
        case EXTERNAL_MAILBOX:
        case MAILBOX:
        case ONE_OFF:
        case CONTACT:
        case IMPLICIT_CONTACT:
        case LINKED_IN:
            return true;
        default:
            if (mailboxType && !isDLOrGroup(mailboxType) && !isUnsupportedRecipient(mailboxType)) {
                trace.errorThatWillCauseAlert('UnknownMailboxType: ' + mailboxType);
            }
            return false;
    }
}

function isUnsupportedRecipient(mailboxType: string) {
    switch (mailboxType) {
        case PUBLIC_FOLDER:
        case OTHER:
        case ROOM:
            return true;
        default:
            return false;
    }
}
